import { inflate } from 'pako';

/**
 * Decompresses a Base64-encoded, Gzip-compressed string.
 * @param compressedData - The Base64-encoded string to decompress.
 * @returns The decompressed data as a parsed JSON object.
 */
export function decompressData<T>(compressedData: string): T {
  const binaryString = atob(compressedData);

  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const infBytes = inflate(bytes);
  const infString = new TextDecoder().decode(infBytes);
  const infData = JSON.parse(infString);

  return infData as T;
}
